import React, { memo } from 'react'
import { TableCell } from 'transfix-ui/components/Table'
import Typography from 'transfix-ui/core/Typography'
import { LaneAlert } from 'apps/marketplace/apiTypes/carrierLaneAlerts'
import formatCurrency from 'utils/formatCurrency'

interface ISavedLanesTableMinTotalRateCellProps
  extends Pick<LaneAlert, 'id' | 'rate' | 'rateType'> {}
export const SavedLanesTableMinTotalRateCell = memo(
  ({ id, rate, rateType }: ISavedLanesTableMinTotalRateCellProps) => {
    return (
      <TableCell dataTest={`saved-lane-${id}-min-total-rate`}>
        <Typography variant='body2' component='div'>
          {rate ? <span>{formatCurrency(rate)}</span> : <span>Any Rate</span>}
        </Typography>
        {!!rateType && (
          <Typography variant='caption' color='textSecondary' component='div'>
            {rateType === 'rpm' && <span>Rate Per Mile</span>}
            {rateType === 'all_in' && <span>Total All-in</span>}
          </Typography>
        )}
      </TableCell>
    )
  }
)
